module.exports = __webpack_public_path__ + "img/gen-rocket.81d13ff3.jpg";